/**
 * Bulk user-tag payload assembly utilities (Spec 294, #294).
 *
 * Extracted as pure functions so they can be tested per ADR-048 Stage 1
 * (vitest, environment: node, no jsdom required).
 */

/**
 * Merges the confirmed `bulkTags` list with the still-pending `newTag` input
 * and returns the final `userTags` list for the accept payload.
 *
 * Rules (Spec 294 E1–E3):
 *   - Confirmed tags come first, in their original order (E1).
 *   - `newTag` is trimmed before use (E2).
 *   - If the trimmed value is empty or already present in `bulkTags`, it is
 *     silently discarded — no empty tag, no duplicate (E2, E3).
 */
export function mergeBulkTags(bulkTags: string[], newTag: string): string[] {
  const trimmed = newTag.trim();
  if (!trimmed || bulkTags.includes(trimmed)) {
    return [...bulkTags];
  }
  return [...bulkTags, trimmed];
}
